<template>
  <div class="newsletter-section section-space--ptb_60 default-bg" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-10 ml-auto mr-auto">
          <div
            class="
              section-title-wrapper
              text-center
              section-space--mb_50
              move-up
            "
          >
            <h3 class="section-title text-white">
              Ready To Embrace The Future Of Healthcare?
            </h3>
          </div>
          <div
            class="
              newsletter-form--one
              section-space--mb_20
              text-center
              wow
              move-up
            "
          >
            <div
              class="clinic-button section-space--mb_50"
              style="text-align: center"
            >
              <b-link
                href="https://www.linkedin.com/in/nichealpham"
                class="ht-btn ht-btn-lg ht-btn--outline"
                style="margin: 0 1rem 1rem; color: white; border-color: white;width:300px"
              >
                Leave us a Message
              </b-link>
              <button
                @click="bookMeeting"
                type="submit"
                class="ht-btn ht-btn-lg"
                style="
                  margin: 0 1rem;
                  color: white;
                  border-color: white;
                  border-width: 2px;
                  width:300px
                "
              >
                Book a Demo Appointment
              </button>
            </div>
          </div>
          <!-- newsletter text -->
          <h6 class="text-white text-center wow move-up">
            What’s next in our long-term goal?
            <a
              href="https://viewer.diagrams.net/?highlight=0000ff&edit=_blank&layers=1&nav=1&title=Overview%20of%20IT%20Platform#Uhttps%3A%2F%2Fdrive.google.com%2Fuc%3Fid%3D1VmygIAKkp0u9LkoMY-MKoOmlewOPZtzY%26export%3Ddownload"
              class="hover-style-link hover-style-link--green"
              >Take a look</a
            >
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsletter",
  methods: {
    bookMeeting() {
      window.open("https://calendly.com/nichealpham/experiment1et");
    },
  },
};
</script>
